import { Box, Chip } from "@mui/material";

/**
 * Chip-based Selector Component
 * Great for status selection and small lists
 */

export default function ChipSelector({
    items = [],
    value,
    setValue,
    size = "medium",
    color = "primary",
    variant = "filled" // "filled" or "outlined"
}) {
    return (
        <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1.5,
            alignItems: 'center'
        }}>
            {items.map((item) => {
                const isSelected = item.value === value;
                return (
                    <Chip
                        key={item.value}
                        label={item.name}
                        onClick={() => setValue(item.value)}
                        size={size}
                        color={isSelected ? color : "default"}
                        variant={isSelected ? "filled" : "outlined"}
                        sx={{
                            cursor: 'pointer',
                            fontWeight: isSelected ? 600 : 500,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            },
                            ...(isSelected && {
                                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                            })
                        }}
                    />
                );
            })}
        </Box>
    );
}

